import { type FC } from 'react';

import { Toggle } from 'src/components/buttons-and-actions/switch';
import { Label } from 'src/components/form/label';

export const NewDesignToggleSkeleton: FC = () => {
  return (
    <div
      className={`
        grid items-center justify-between gap-md bg-background-surface-subdued
        px-2xl py-lg
        md:grid-cols-[1fr_auto]
      `}
    >
      <span className="invisible" aria-hidden>
        Use the new PRISMA Platform design - clearer workflow, better
        experience. Read the summary of all changes. Please leave feedback.
      </span>
      <div
        className={`
          invisible grid grid-flow-col items-center justify-end gap-md
        `}
        aria-hidden
      >
        <Label>New Design</Label>
        <Toggle label="New Design" isChecked onChange={() => {}} />
      </div>
    </div>
  );
};
